import { render, staticRenderFns } from "./wap-template-select.vue?vue&type=template&id=265850b1&"
import script from "./wap-template-select.vue?vue&type=script&lang=js&"
export * from "./wap-template-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "wap-template-select.vue"
export default component.exports